import { render, staticRenderFns } from "./TutorialCarouselDialog.vue?vue&type=template&id=c0df4958&scoped=true"
import script from "./TutorialCarouselDialog.vue?vue&type=script&lang=js"
export * from "./TutorialCarouselDialog.vue?vue&type=script&lang=js"
import style0 from "./TutorialCarouselDialog.vue?vue&type=style&index=0&id=c0df4958&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0df4958",
  null
  
)

export default component.exports